// temporary interface until letrusAPI interfaces is updated
export interface LearningPathTemp {
  id: number;
  steps: LearningPathNestedStep[];
  status: 'in_progress' | 'scheduled' | 'expired' | 'finished';
  step_number: number;
  name: string;
  description: string;
  review_grid_id: number;
  get_opinion: boolean;
  started?: string;
  start_datetime?: string;
  end_datetime?: string;
  is_knowledge_learning_path?: boolean;
  viewed_opinion?: boolean;
  learning_path_type?:
    | 'letrus'
    | 'school'
    | 'knowledge'
    | 'competence'
    | 'mediated reading'
    | 'diagnostics'
    | 'special'
    | 'sensitization and interpretation'
    | 'self-evaluation'
    | 'ede'
    | 'evaluative'
    | 'other';
}

export interface LearningPathNestedStep {
  id: number;
  activity_type: string;
  activity_status?: string;
  activity_id?: number;
  order: number;
  available?: boolean;
}

export interface LearningPathStepTemp {
  id: number;
  composition_status?:
    | 'writing'
    | 'finished'
    | 'automatic review running'
    | 'manual review pending'
    | 'teacher revision pending'
    | 'reviewed'
    | 'preparing';
  parent_id?: number;
  child_id?: number;
  current_step_order: number;
  activity_id: number;
  activity_type: 'write' | 'pedagogical content' | 'questionnaire';
  available: boolean;
  step_id: number;
  test?: {
    id: number;
    theme_id: number;
    uses_write_preparation: boolean;
  };
}

export enum StepTypeTexts {
  'questionnaire' = 'Questionário',
  'pedagogical content' = 'Leitura',
  'write' = 'Escrita',
  'rewrite' = 'Reescrita',
}
